import {
  IconMapWalk16,
  IconMapCar16,
  IconInfrastructureHospital16,
  IconInfrastructureKid16,
  IconInfrastructureSchool16,
  IconInfrastructureStore16,
} from '@cian/ui-kit-design-tokens/icons';
import { EInfrastructureType, ETravelType, ICoordinates } from './types';
import { MainPinIcon } from '../../../components/Infrastructure';

export const YANDEX_API_KEY = 'valuation.YandexApiKey';
export const YANDEX_SUGGEST_API_KEY = 'valuation.YandexSuggestApiKey';

export const DEFAULT_MAP_CENTER: ICoordinates = { lng: 37.621202, lat: 55.753544 };

export const INFRASTRUCTURE_MAP_ICON = {
  [EInfrastructureType.Main]: MainPinIcon,
  [EInfrastructureType.Clinic]: IconInfrastructureHospital16,
  [EInfrastructureType.Grocery]: IconInfrastructureStore16,
  [EInfrastructureType.Nursery]: IconInfrastructureKid16,
  [EInfrastructureType.School]: IconInfrastructureSchool16,
};

export const INFRASTRUCTURE_TYPE_LABEL = {
  [EInfrastructureType.Clinic]: 'MapChoosePolyclinic',
  [EInfrastructureType.Grocery]: 'MapChooseGroceryStore',
  [EInfrastructureType.Nursery]: 'MapChooseKindergarten',
  [EInfrastructureType.School]: 'MapChooseSchool',
};

export const ALWAYS_VISIBLE_INFRASTRUCTURE_TYPES: string[] = [EInfrastructureType.Main];

export const METRO_TRAVEL_TYPE_ICON = {
  [ETravelType.ByFoot]: IconMapWalk16,
  [ETravelType.ByCar]: IconMapCar16,
};
